import { MessageCircle, MessagesSquare } from "lucide-react";

export default function ChatEmptyState() {
  return (
    <div className="relative flex-1 flex flex-col items-center justify-center text-center p-8 overflow-hidden bg-gradient-to-b from-slate-50 via-white to-[hsl(158,48%,36%)]/5 dark:from-slate-950 dark:via-slate-900 dark:to-[hsl(158,48%,36%)]/10 animate-fade-in">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.35] dark:opacity-[0.2]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgb(148 163 184 / 0.35) 1px, transparent 0)",
          backgroundSize: "22px 22px",
        }}
        aria-hidden
      />

      <div className="relative z-[1] flex flex-col items-center max-w-md">
        <div className="relative mb-7">
          <div className="absolute inset-0 rounded-3xl bg-[hsl(158,48%,36%)]/20 blur-2xl scale-125" aria-hidden />
          <div className="relative h-24 w-24 rounded-3xl bg-white dark:bg-slate-900 border border-[hsl(158,48%,36%)]/25 dark:border-[hsl(158,48%,36%)]/30 shadow-sm flex items-center justify-center">
            <MessagesSquare className="h-11 w-11 text-[hsl(158,48%,32%)] dark:text-[hsl(158,45%,55%)]" strokeWidth={1.5} />
          </div>
          <div className="absolute -bottom-2 -right-2 h-9 w-9 rounded-xl bg-[hsl(158,48%,36%)] text-white flex items-center justify-center shadow-md">
            <MessageCircle className="h-[18px] w-[18px]" />
          </div>
        </div>

        <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-gray-900 dark:text-white mb-2">
          WhatsApp inbox
        </h2>
        <p className="text-sm sm:text-base text-gray-500 dark:text-slate-400 leading-relaxed mb-6">
          Select a conversation on the left to read and reply.
          <br className="hidden sm:block" />
          Messages stay in sync without keeping your phone online.
        </p>

        <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 dark:border-slate-700 bg-white/80 dark:bg-slate-900/80 px-3.5 py-1.5 text-xs font-medium text-slate-600 dark:text-slate-300 backdrop-blur-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-[hsl(158,48%,36%)] animate-pulse" />
          Ready when you pick a chat
        </div>
      </div>
    </div>
  );
}
